import React from 'react';
import { styled } from '@ff/ui';

export default function ErrorMessageBlock({ errorMessage }) {
  return <Container>{errorMessage}</Container>;
}

const Container = styled.Box({
  background: 'black',
  color: 'red',
  padding: 70,
  textAlign: 'center'
})
